import CompanyPageVcmsBody from '@/containers/CompanyPageVcmsBody/desktop';
import { SEO_PAGE_TYPE } from '@/utils/constants';
import { useAppSelector } from '@/utils/hook';
import { slugifyString } from '@/utils/slugifyString';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import CompanyPageMetaHeader from './header';

export interface IObjectState {
  [key: string]: any;
}

export const AIRLINES: IObjectState = {
  'vietnam-airlines': {
    type: 'VN',
    name: 'Vietnam Airlines',
    img: 'https://vanphongvemaybay.vn/wp-content/uploads/Vietnam-Airlines-Office-Banner.jpg',
    slug: 'vietnam-airlines',
  },
  'vietjet-air': {
    type: 'VJ',
    name: 'Vietjet Air',
    img: 'http://lamnguyentravel.com/public/uploads/images/images/VJ%20quang%20cao.gif',
    slug: 'vietjet-air',
  },
  'bamboo-airways': {
    type: 'QH',
    name: 'Bamboo Airways',
    img: 'https://d3jyiu4jpn0ihr.cloudfront.net/wp-content/uploads/sites/6/20190119120151/thumbnail-facebook.jpg',
    slug: 'bamboo-airways',
  },
  'vietravel-airlines': {
    type: 'VU',
    name: 'Vietravel Airlines',
    img: 'https://upload.wikimedia.org/wikipedia/commons/e/ee/Vietravel_Airlines_Logo.png',
    slug: 'vietravel-airlines',
  },
  'pacific-airlines': {
    type: 'BL',
    name: 'Pacific Airlines',
    img: 'https://storage.googleapis.com/goyolo-production/logo-pacific-airlines.jpeg',
    slug: 'pacific-airlines',
  },
};
function CompanyPageContainer({
  isDesktop = false, company, company2, startPoint, toPoint, countResult, countSeoResult, countSeoReturnResult, countSeoAllResult, flightResult, pageType, countTetResult, countSeoTetResult, tetData, templateDataObj, route, airport, imagePromotion, isTrain,
}: {
  isDesktop?: boolean, company?: any, company2?: any, startPoint?: any, toPoint?: any, countResult?: any, countSeoResult?: any, countSeoReturnResult?: any, countSeoAllResult?: any, flightResult?: any, pageType: SEO_PAGE_TYPE, templateDataObj: any,
  countTetResult?: any, countSeoTetResult?: any, tetData: any, route?: any, airport: any, imagePromotion?: any, isTrain?: boolean
}) {
  // const dispatch = useDispatch();
  const router = useRouter();
  const searchFlightForm = useAppSelector((state) => state.searchFlightForm);
  const [canSwitch, setCanSwitch] = useState(false);
  const branchPage: IObjectState = AIRLINES[company || ''];
  // const headerTabs = useAppSelector((state) => state.headerTabs || 0);
  // const [getFlightDepartById, { data: flightById }] = useLazyGetFlightByIdQuery();
  useEffect(() => {
    setTimeout(() => {
      let ext = '';
      const from = templateDataObj?.lang?.lang === 'en' ? 'from' : 'tu';
      const to = templateDataObj?.lang?.lang === 'en' ? 'to' : 'di';
      if (searchFlightForm?.startPointHome || searchFlightForm?.toPointHome) {
        switch (pageType) {
          case SEO_PAGE_TYPE.FROM_TO_PAGE:
            ext = `${from}-${slugifyString(
              searchFlightForm?.startPointHome?.location,
            )}-${to}-${slugifyString(searchFlightForm?.toPointHome?.location)}.${searchFlightForm?.startPointHome?.stateId}.${
              searchFlightForm?.toPointHome?.stateId
            }.${templateDataObj?.lang?.lang}`;
            break;
          case SEO_PAGE_TYPE.AIRLINE_FROM_TO_PAGE:
            ext = `${
              templateDataObj?.calculatedParams?.company
            }-${from}-${slugifyString(
              searchFlightForm?.startPointHome?.location,
            )}-${to}-${slugifyString(searchFlightForm?.toPointHome?.location)}.${
              searchFlightForm?.startPointHome?.stateId
            }.${searchFlightForm?.toPointHome?.stateId}.${
              templateDataObj?.lang?.lang
            }`;
            break;
          case SEO_PAGE_TYPE.TO_PAGE:
            ext = `${to}-${slugifyString(
              searchFlightForm?.toPointHome?.location,
            )}.${searchFlightForm?.toPointHome?.stateId}.${
              templateDataObj?.lang?.lang
            }`;
            break;
          case SEO_PAGE_TYPE.AIRLINE_TO_PAGE:
            ext = `${
              templateDataObj?.calculatedParams?.company
            }-${to}-${slugifyString(searchFlightForm?.toPointHome?.location)}.${
              searchFlightForm?.toPointHome?.stateId
            }.${templateDataObj?.lang?.lang}`;
            break;
          default:
            break;
        }
      }
      if (ext && window.location.href) {
        const currExt = window.location.href?.split('/');
        const currExtStr = currExt[currExt.length - 1];

        if (currExtStr === ext || currExtStr?.replace('sai-gon', 'ho-chi-minh') === ext || currExtStr?.replace('ho-chi-minh', 'sai-gon') === ext) {
          setCanSwitch(true);
        }

        if (!((currExtStr === ext) || currExtStr?.replace('sai-gon', 'ho-chi-minh') === ext || currExtStr?.replace('ho-chi-minh', 'sai-gon') === ext) && canSwitch) {
          currExt[currExt.length - 1] = ext;
          window.location.href = currExt.join('/');
        }
      }
    }, 1000);
  }, [searchFlightForm]);

  // if (company && !branchPage) {
  console.log('🚀 ~ file: desktop.tsx:118 ~ branchPage:', branchPage);
  console.log('🚀 ~ file: desktop.tsx:118 ~ company:', company);
  //   router.push('/');
  //   return <div />;
  // }
  // const handleSelectTrip = (item: any) => {
  //   if (item?.id) {
  //     getFlightDepartById({ id: item?.id });
  //   }
  //   dispatch(resetSelectedContact());
  // };

  let path = process.env.GOYOLO_URL + router.asPath;
  if (typeof window !== 'undefined') {
    path = window.location.href;
  }
  return (
    <>
      <CompanyPageMetaHeader
        branchPage={branchPage}
        path={path}
        route={route}
        pageType={pageType}
      />
      <CompanyPageVcmsBody
        isTrain={isTrain}
        imagePromotion={imagePromotion}
        airport={airport}
        isDesktop={isDesktop}
        startPoint={startPoint}
        toPoint={toPoint}
        company={company}
        // templateData={templateData}
        // templateParamObj={templateParamObj}
        // calculatedParams={calculatedParams}
        countResult={countResult}
        countTetResult={countTetResult}
        countSeoTetResult={countSeoTetResult}
        templateDataObj={templateDataObj}
        tetData={tetData}
        // lang={lang}
        // handleSelectTrip={handleSelectTrip}
      />
    </>
  );
}

export default CompanyPageContainer;
